module.exports = __webpack_public_path__ + "img/news_top_img.364d5fc.webp";